const initialState = {
  ausbilderListe: [],
  abteilungen: undefined,
}

export default function meineAusbilder(state = initialState) {
  return state
}
